import styled, { keyframes } from 'styled-components';

const fadeIn = keyframes`
  from {
    opacity: .5;
  }

  to {
    opacity: 1;
  }
`;

export const LoadingHeading = styled.div`
  margin-bottom: 60px;
  height: 70px;
  width: 400px;
  max-width: 100%;
  background-color: rgba(0, 0, 0, 0.03);
  animation: ${fadeIn} 1s linear alternate infinite;
`;

export const LoadingPreamble = styled.div`
  margin: 47px 0 30px;
  height: 31px;
  width: 95%;
  background-color: rgba(0, 0, 0, 0.03);
  animation: ${fadeIn} 1s linear alternate infinite;

  &:before {
    content: '';
    height: 31px;
    width: 98%;
    background-color: rgba(0, 0, 0, 0.03);
    display: block;
    top: -125%;
    position: relative;
  }

  &:after {
    content: '';
    height: 31px;
    width: 300px;
    max-width: 100%;
    background-color: rgba(0, 0, 0, 0.03);
    display: block;
    top: 25%;
    position: relative;
  }
`;

export const LoadingBody = styled.div`
  margin: 80px 0 60px;
  height: 600px;
  width: 97%;
  background-color: rgba(0, 0, 0, 0.03);
  animation: ${fadeIn} 1s linear alternate infinite;
`;



// WEBPACK FOOTER //
// ./src/styles/LoadingState.js